import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
import { useImperativeHandle } from "react";
export const useAutosizeTextArea = ({ textAreaRef, triggerAutoSize, maxHeight = Number.MAX_SAFE_INTEGER, minHeight = 0, }) => {
    const [init, setInit] = React.useState(true);
    React.useEffect(() => {
        // We need to reset the height momentarily to get the correct scrollHeight for the textarea
        const offsetBorder = 2;
        if (textAreaRef) {
            if (init) {
                textAreaRef.style.minHeight = `${minHeight + offsetBorder}px`;
                if (maxHeight > minHeight) {
                    textAreaRef.style.maxHeight = `${maxHeight}px`;
                }
                setInit(false);
            }
            textAreaRef.style.height = `${minHeight + offsetBorder}px`;
            const scrollHeight = textAreaRef.scrollHeight;
            // We then set the height directly, outside of the render loop
            // Trying to set this with state or a ref will product an incorrect value.
            if (scrollHeight > maxHeight) {
                textAreaRef.style.height = `${maxHeight}px`;
            }
            else {
                textAreaRef.style.height = `${scrollHeight + offsetBorder}px`;
            }
        }
    }, [init, maxHeight, minHeight, textAreaRef, triggerAutoSize]);
};
export const AutosizeTextarea = React.forwardRef(({ maxHeight = Number.MAX_SAFE_INTEGER, minHeight = 52, className, onChange, value, ...props }, ref) => {
    const textAreaRef = React.useRef(null);
    const [triggerAutoSize, setTriggerAutoSize] = React.useState("");
    useAutosizeTextArea({
        textAreaRef: textAreaRef.current,
        triggerAutoSize: triggerAutoSize,
        maxHeight,
        minHeight,
    });
    useImperativeHandle(ref, () => ({
        textArea: textAreaRef.current,
        focus: () => textAreaRef.current?.focus(),
        maxHeight,
        minHeight,
    }));
    React.useEffect(() => {
        setTriggerAutoSize(value);
    }, [props?.defaultValue, value]);
    return (_jsx("textarea", { ...props, value: value, ref: textAreaRef, className: cn("flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className), onChange: (e) => {
            setTriggerAutoSize(e.target.value);
            onChange?.(e);
        } }));
});
AutosizeTextarea.displayName = "AutosizeTextarea";
//# sourceMappingURL=autosize-textarea.js.map